<template>
    <div>
        <div class="loginContainer">
            <div class="box">
                <div class="login">
                    <div class="col">                    
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <input type="text" id="Account" name="Account" v-model="username" placeholder="Account">
                    </div>
                    <div class="col">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <input type="password" id="Password" name="Password"  v-model="pwd" placeholder="Password"
                            @keydown.enter.exact.prevent="getToken()">
                    </div>

                    <div class="buttondiv">
                        <button class="loginBtn" @click="getToken()">login</button>
                    </div>

                    <div class="errormessagediv">
                        <p class="errormessage">{{errorMsg}}</p>
                    </div>

                    <div class="dropdowndiv">
                        <div class="dropdown">
                            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Language
                            </button>
                            <div class="dropdown-menu dropdown-content" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item">English</a>
                                <a class="dropdown-item">繁體中文</a>
                                <a class="dropdown-item">简体中文</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'

export default {
    name: 'loginPage',
    props: [],
    components:{},
    data () {
        return {
            username:'',
            pwd:'',
            errorMsg:'',
        }
    },
    methods:{
        getToken(){
            if(this.validate()){
                // const api =`https://teststudentcenterapi.hitute.com/api/Login/GetToken`;
                const api =`${process.env.APIPATH}/api/Login/GetToken`;
                var data={}

                axios.post(api, data, { auth: {username: this.username, password: this.pwd} })
                .then((response) => {
                        if(response.data.IsSuccess){
                            sessionStorage.setItem('Token',response.data.Token);
                            sessionStorage.setItem('UserId',response.data.UserId);
                            this.ToHome();
                        }else{
                            this.errorMsg = response.data.Message
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                    });
            }
        },
        validate(){
            if(this.username == ''){
                this.errorMsg = "請輸入帳號。"
                return false;
            }else if(this.pwd == ''){
                this.errorMsg = "請輸入密碼。"
                return false;
            }else{
                return true;
            }
        },
        ToHome(){
            this.$router.push({
                name: 'Home',
                params: {
                    // NeedLogin:false,
                }
            });
        },
    },
    created(){
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/loginPage.vue